// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12EiJ","col":"styles_col__2vvhA","actions":"styles_actions__QHKa1","conflict":"styles_conflict__1ICqe"};